var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagType,_vm._g(_vm._b({ref:"target",tag:"component",class:`cv-tile-clickable ${_vm.carbonPrefix}--tile--clickable`,attrs:{"data-tile":"clickable","tabindex":"0"}},'component',_vm.linkProps,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }